import { useEffect, useState } from "react";
import { AdminLayout } from "../../components/AdminLayout";
import { DataTable } from "../../components/DataTable";
import { adminHeaders, api } from "../../lib/api";

export function ModuleAdminPage({ title, code, text }: { title: string; code: string; text: string }) {
  const [rows, setRows] = useState<Record<string, unknown>[]>([]);
  useEffect(() => { api<Record<string, unknown>[]>(`/api/admin/activity-settings?activityCode=${code}`, { headers: adminHeaders() }).then(setRows).catch(console.error); }, [code]);
  return (
    <AdminLayout title={title}>
      <section className="action-panel">
        <h2>模組設定</h2>
        <p>{text}</p>
      </section>
      <DataTable rows={rows} />
    </AdminLayout>
  );
}
